"use client";

import { TextInput } from "@astryxdesign/core/TextInput";
import { Icon } from "@astryxdesign/core/Icon";
import { researchIcons } from "@/lib/icons/research-icons";
import { formatRuPhoneInput } from "@/lib/phone/ru-phone";
import { webmcpParam } from "@/lib/webmcp/lead-form";

type RuPhoneInputProps = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  htmlName?: string;
  isRequired?: boolean;
  isOptional?: boolean;
  isLabelHidden?: boolean;
  error?: string | null;
  hasAutoFocus?: boolean;
  onBlur?: () => void;
};

export function RuPhoneInput({
  label = "Телефон",
  value,
  onChange,
  htmlName = "phone",
  isRequired = false,
  isOptional = !isRequired,
  isLabelHidden = false,
  error = null,
  hasAutoFocus = false,
  onBlur,
}: RuPhoneInputProps) {
  return (
    <TextInput
      label={label}
      isLabelHidden={isLabelHidden}
      htmlName={htmlName}
      value={value}
      onChange={(next) => onChange(formatRuPhoneInput(next))}
      placeholder="+7 (___) ___-__-__"
      isRequired={isRequired}
      isOptional={isOptional}
      hasAutoFocus={hasAutoFocus}
      startIcon={<Icon icon={researchIcons.phone} size="sm" color="secondary" />}
      status={
        error
          ? { type: "error" as const, message: error }
          : undefined
      }
      onKeyDown={(e) => {
        if (e.key === "Enter") onBlur?.();
      }}
      onBlur={onBlur}
      {...webmcpParam("Телефон в формате +7 (XXX) XXX-XX-XX")}
    />
  );
}
